<template>
  <div class="card card-modern card-modern-table-over-header mb-4">
    <div class="card-header">
      <div class="card-actions">
        <a
          class="card-action card-action-toggle"
          href="#recent-orders"
          data-bs-toggle="collapse"
        />
      </div>
      <h2 class="card-title">Nedavne narudžbe</h2>
    </div>
    <div class="card-body show" id="recent-orders">
      <div class="datatables-header-footer-wrapper">
        <div class="datatable-header">
          <div class="row align-items-center mb-3">
            <div class="col-8 col-lg-auto ms-auto ml-auto mb-3">
            </div>
          </div>
        </div>

        <div
          id="datatable-ecommerce-list_wrapper"
          class="dataTables_wrapper dt-bootstrap5 no-footer"
        >
          <div class="table-responsive">
            <table
              class="
                table
                table-ecommerce-simple
                table-borderless
                table-striped
                mb-0
                dataTable
                no-footer
              "
              id="datatable-ecommerce-list"
              style="min-width: 640px"
              role="grid"
              aria-describedby="datatable-ecommerce-list_info"
            >
              <thead>
                <tr role="row">
                  <th
                    width="8%"
                    class="sorting"
                    tabindex="0"
                    aria-controls="datatable-ecommerce-list"
                    rowspan="1"
                    colspan="1"
                    aria-label="ID: activate to sort column ascending"
                    style="width: 46.375px"
                  >
                    ID
                  </th>
                  <th
                    width="28%"
                    class="sorting"
                    tabindex="0"
                    aria-controls="datatable-ecommerce-list"
                    rowspan="1"
                    colspan="1"
                    aria-label="Customer Name: activate to sort column ascending"
                    style="width: 234.828px"
                  >
                    Korisnik / kompanija
                  </th>
                  <th
                    width="18%"
                    class="sorting"
                    tabindex="0"
                    aria-controls="datatable-ecommerce-list"
                    rowspan="1"
                    colspan="1"
                    aria-label="Date: activate to sort column ascending"
                    style="width: 140.609px"
                  >
                    Datum narudžbe
                  </th>
                  <th
                    width="18%"
                    class="sorting"
                    tabindex="0"
                    aria-controls="datatable-ecommerce-list"
                    rowspan="1"
                    colspan="1"
                    aria-label="Total: activate to sort column ascending"
                    style="width: 140.609px"
                  >
                    Ukupno
                  </th>
                  <th
                    width="15%"
                    class="sorting"
                    tabindex="0"
                    aria-controls="datatable-ecommerce-list"
                    rowspan="1"
                    colspan="1"
                    aria-label="Status: activate to sort column ascending"
                    style="width: 112.359px"
                  >
                    Status
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr role="row" :class="{ odd: index % 2 == 0, even: index % 2 == 1 }" v-for="(item, index) in dashboardData.recentOrders" :key="index">
                  <td>
                    <router-link
                      :to="{ name: 'EditOrder', params: { id: item.id } }"
                    >
                      <strong>{{ item.id }}</strong>
                    </router-link>
                  </td>
                  <td>
                    <router-link
                      :to="{ name: 'EditOrder', params: { id: item.id } }"
                    >
                      <strong>{{ item.customerName }} / {{ item.companyName }} </strong>
                    </router-link>
                  </td>
                  <td>{{ formatDate(item.createdDate, 'dd.MM.yyyy HH:mm') }}</td>
                  <td>{{ item.total | money2 }}</td>
                  <td>
                    <!-- <span class="ecommerce-status on-hold">On Hold</span> -->
                    <!-- <span class="ecommerce-status">
                      {{ item.orderStatus }}
                    </span> -->
                    <!-- <span class="ecommerce-status canceled">Canceled</span> -->
                    <!-- <span class="ecommerce-status on-hold">On Hold</span> -->
                    <!-- <span class="ecommerce-status processing">Processing</span> -->
                    <!-- <span class="ecommerce-status completed">Completed</span> -->
                    <!-- <span class="ecommerce-status canceled"> Canceled </span> -->
                    <span class="ecommerce-status processing">{{ mapOrderStatus(item.orderStatus) }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns';
import helpers from '@/services/helpers';

export default {
  name: 'RecentOrders',
  computed: {
    dashboardData() {
      return this.$store.getters.getDashboardData;
    },
  },
  methods: {
    formatDate(date, dateFormat) {
      return format(new Date(date), dateFormat);
    },
    mapOrderStatus(id) {
      return helpers.mapOrderStatus(id);
    },
  },
};
</script>
